import {
  BASE_URL,
  INDEX_UR
} from "./config.js"
import axios from 'axios';

// let url = "https://www.life-health.net/"
let url = "https://hmfgw.imlimit.com/"
let getAxios = function(options) {
  return new Promise((resolve, reject) => {
    axios.get(BASE_URL + options.url, {
        params: options.data
      })
      .then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
  })
}
let postAxios = function(options) {
  return new Promise((resolve, reject) => {
    axios.post(BASE_URL + options.url, options.data)
      .then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
  })

}
export {
  getAxios,
  postAxios
}



//////////////////
// WEBPACK FOOTER
// ./common/req.js
// module id = UlOJ
// module chunks = 14